import * as angular from 'angular';
import { TranscriptionMfeService } from './TranscriptionMfeService';
export const transcriptionModule = angular
    .module('app.transcriptions', [])
    .service('TranscriptionMfeService', TranscriptionMfeService)
    .name;
